export default "__VITE_ASSET__b30aafdc__"